import { connect } from 'react-redux';

import { Hint } from 'CorePackage/MainModule/components/Hint';

import styles from './ErknmFillInProcessMessage.module.scss';

interface IErknmFillInProcessMessageProps {
  message?: string;
}

interface IErknmFillInProcessMessageStoreProps {}

const HadToBeHowInSignMessageWithoutStore = ({
  message,
}: IErknmFillInProcessMessageProps & IErknmFillInProcessMessageStoreProps) => {
  return (
    <div className={styles.FillInProcessMessage}>
      <Hint text={message || ''} />
    </div>
  );
};

const mapStateToProps = (): IErknmFillInProcessMessageStoreProps => ({});

export const HadToBeHowInSignMessage = connect(mapStateToProps)(HadToBeHowInSignMessageWithoutStore);
